'use strict';

angular.module('saturdayBall', [
  'ngRoute',
  'ngAnimate',
  'ui.bootstrap',
  'updateMeta',
  'uiCropper'
]);